var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.edit)?[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('lsIcon',{staticStyle:{"cursor":"pointer"},attrs:{"type":_vm.icon,"size":14},nativeOn:{"click":function($event){return _vm.changeEdit.apply(null, arguments)}}})]:[_c('a-input',{ref:"input",attrs:{"value":_vm.value},on:{"change":_vm.inputChange,"blur":_vm.inputBlur}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }